import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import { RevealFade } from "../fx/Common";

export default class ContactForm extends Component {
  mount() {
    this.DOM = {};
    this.DOM.formContainer = this.element.querySelector(".wpcf7");
    this.DOM.formElement = this.DOM.formContainer.querySelector("form");

    if (Env.isVisiting == true) {
      wpcf7.init(this.DOM.formElement);
    }
    this.events();
    this.customFieldFile();
  }

  customFieldFile() {
    var inputs = document.querySelectorAll(".field-file");
    Array.prototype.forEach.call(inputs, function (input) {
      const label = input.parentElement.parentElement.querySelector("label");
      const labelVal = label.innerHTML;

      input.addEventListener("change", function (e) {
        var fileName = "";
        if (this.files && this.files.length > 1) {
          fileName = (this.getAttribute("data-multiple-caption") || "").replace(
            "{count}",
            this.files.length
          );
        } else {
          fileName = e.target.value.split("\\").pop();
        }
        if (fileName) {
          label.querySelector(".js-filename").innerHTML = fileName;
        } else {
          label.innerHTML = labelVal;
        }
      });
    });
  }

  events() {
    this.DOM.formContainer.addEventListener(
      "wpcf7submit",
      function (event) {
        setTimeout(() => {
          if (typeof Env.framework.UI.smoothie != "undefined") {
            Env.framework.UI.smoothie.update();
          }
        }, 250);
        setTimeout(() => {
          Channels.emit("grid::update");
        }, 350);
      },
      false
    );
  }
}
